import { render, staticRenderFns } from "./fileHeader.vue?vue&type=template&id=f0a128f8&scoped=true&lang=pug"
import script from "./fileHeader.vue?vue&type=script&lang=js"
export * from "./fileHeader.vue?vue&type=script&lang=js"
import style0 from "./fileHeader.vue?vue&type=style&index=0&id=f0a128f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a128f8",
  null
  
)

export default component.exports